import { AppBar, Box, Toolbar, TextField, Modal, useTheme, Table, TableCell, TableBody, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Divider, CssBaseline, alpha, Tooltip, } from "@mui/material";
import { useState, useEffect } from "react";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';

import Searchicon from '@mui/icons-material/Search';

import CustomTableContainer from "../../../Layout/CustomTableContainer";
import { callApi } from "../../../pages/commonapicall/fetchdata";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { tokens } from "../../../theme/theme";

import AddNewBintypeMaster from "./AddNewBintypeMaster";

import useUserPermissions from "../../../components/user-permission/UserPermission";
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import ModuleHelpDialog from "../../../components/ModuleHelpDialog";
import { moduleHelpData } from "../../../data/moduleHelpData";
import useWarehouseBinTypeList from "../../../hooks/warehouse/useWarehouseBinTypeList";

const BintypeMaster = ({ handleBackWinderMachineEntry, reelID }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Bin types');
    const openFirst = Boolean(anchorElFirst);
    const [newLocation, setNewLocation] = useState(false);
    const [warehouseList, setWarehouseList] = useState(true);
    const [warehouseSlots, setWarehouseSlots] = useState(false);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    const [directStoreMode, setDirectStoreMode] = useState(false);
    const { warehouseBinTypes, setWarehouseBinTypes, loadWarehouseBinTypeByID } = useWarehouseBinTypeList(null, 0);

    const [partyList, setPartyList] = useState([]);

    const [open, setOpen] = useState(false);
    const [helpOpen, setHelpOpen] = useState(false);
    const handleCloseHelp = () => setHelpOpen(false);
    const handleHelpMenuClick = () => setHelpOpen(true);

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Bin types') {
            setSelectedStatus('All');
        }
        else if (option === 'Active Bin types') {
            setSelectedStatus(true);
        }
        else if (option === 'Inactive Bin types') {
            setSelectedStatus(false);
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const handleShowNewVendor = () => {
        setEditPartyID(0);
        setWarehouseList(false);
        setWarehouseSlots(false);
        setNewLocation(true);
        setSelectedWarehouse(null);
    }

    const handlecallback = () => {
        setEditPartyID(0);
        setWarehouseList(true);
        setWarehouseSlots(false);
        setNewLocation(false);
        loadWarehouseBinTypeByID(0);
    }


    useEffect(() => {
        // alert('selected reel id :' + reelID);
        setDirectStoreMode(true);
    }, [reelID]);



    const [filters, setFilters] = useState({
        code: '',
        description: '',
        allow_multiple_items: '',
        limit_type: '',
        max_different_skus: '',
        location_code_format: '',
        is_stackable: '',
        vertical_gap_in_cm: '',
    });

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelectedRows = partyList.map((row) => row.id);
            setSelectedRows(newSelectedRows);
            return;
        }
        setSelectedRows([]);
    };

    const handleRowCheckboxClick = (event, rowId) => {
        const selectedIndex = selectedRows.indexOf(rowId);
        let newSelectedRows = [];

        if (selectedIndex === -1) {
            newSelectedRows = [...selectedRows, rowId];
        } else if (selectedIndex === 0) {
            newSelectedRows = selectedRows.slice(1);
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelectedRows = selectedRows.slice(0, -1);
        } else if (selectedIndex > 0) {
            newSelectedRows = [
                ...selectedRows.slice(0, selectedIndex),
                ...selectedRows.slice(selectedIndex + 1),
            ];
        }

        setSelectedRows(newSelectedRows);

        if (newSelectedRows.length > 0) {
            setShowNewToolbar(true); // Show new toolbar when rows are selected
            setShowFirstToolbar(false);
        } else {
            setShowNewToolbar(false); // Hide new toolbar when no rows are selected
            setShowFirstToolbar(true);
        }
    };

    const isSelected = (rowId) => selectedRows.indexOf(rowId) !== -1;


    const [selectedRows, setSelectedRows] = useState([]);
    const [showFirstToolbar, setShowFirstToolbar] = useState(true);
    const [showNewToolbar, setShowNewToolbar] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('All');

    const filteredData = warehouseBinTypes.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const [editPartyID, setEditPartyID] = useState(0)

    const [selectedwarehosue, setSelectedWarehouse] = useState({})
    const handleCallEdit = (row) => {
        setSelectedWarehouse(row);
        setWarehouseList(false);
        setNewLocation(true);
    };
    const userPermissions = useUserPermissions();

    return (
        <Box>
            <CssBaseline />


            {warehouseList && (<>
                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="secondary"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                        >
                            {selectedOptionFirst}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}

                        >
                            <MenuItem onClick={() => handleMenuItemClickFirst('All Bin types')}>All Bin types</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Active Bin types')}>Active Bin types</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Inactive Bin types')}>Inactive Bin types</MenuItem>
                        </Menu>


                        {hasPermission(userPermissions, "Bin type", "Create") && (

                            <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>


                        )}
                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ ml: 2 }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon sx={{ fontSize: "18px" }} />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Vendors" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Vendors" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>
                                {/* <ListItemIcon>
                                    <FormatAlignJustifyIcon />
                                </ListItemIcon>
                                <ListItemText primary="Reset Column Width" /> */}
                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                          <Tooltip title="View help document details" arrow>
                          <IconButton
                            size="small"
                            aria-label="help"
                            sx={{ mx: 1 }}
                            onClick={handleHelpMenuClick}
                          >
                            <HelpIcon sx={{ fontSize: 18 }} />
                          </IconButton>
                        </Tooltip>



                        <ModuleHelpDialog
                            open={helpOpen}
                            onClose={handleCloseHelp}
                            data={moduleHelpData.BinTypeMaster}
                        />

                        <div>
                            <IconButton onClick={handleBackWinderMachineEntry} >
                                <Close fontSize="inherit" style={{ fontSize: "18px", color: "#2196F3" }} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>

                <CustomTableContainer colors={colors}>
                    <TableContainer >
                        <Table size="small">
                            <TableHead sx={{ backgroundColor: colors.primary[400] }}>
                                <TableRow>
                                    {/* <TableCell>
                                        <Checkbox size="small" style={{ color: "secondary" }}
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                            checked={selectedRows.length === filteredData.length}
                                            onChange={handleSelectAllClick}
                                        />  
                                    </TableCell> */}
                                    <TableCell sx={{ textAlign: 'center' }}>CODE</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>DESCRIPTION</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>ALLOW MULTIPLE ITEMS</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>LIMIT TYPE</TableCell>
                                    {/* <TableCell>MATCH DIFFERNT SKU'S</TableCell> */}
                                    <TableCell sx={{ textAlign: 'center' }}>LOCATION CODE FORMATE</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>IS STACKABLE</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>HORIZONTAL OBJECT GAP (cm)</TableCell>
                                    <TableCell sx={{ textAlign: 'center' }}>STATUS</TableCell>
                                    <TableCell>
                                        <IconButton onClick={handleOpen}>
                                            <Searchicon style={{ fontSize: "14px" }} />
                                        </IconButton>
                                        <Modal
                                            open={open}
                                            onClose={handleClose}
                                            aria-labelledby="modal-modal-title"
                                            aria-describedby="modal-modal-description"
                                        >
                                            <Box sx={{ position: 'absolute', top: '50%', left: '50%', bgcolor: 'background.paper', transform: 'translate(-50%, -50%)', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                <TextField
                                                    label="Code"
                                                    name="code"
                                                    value={filters.code}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />
                                                <TextField
                                                    label="Description"
                                                    name="description"
                                                    value={filters.description}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />
                                                <TextField
                                                    label="Allow Multiple Items"
                                                    name="allow_multiple_items"
                                                    value={filters.allow_multiple_items}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />
                                                <TextField
                                                    label="Limit Type"
                                                    name="limit_type"
                                                    value={filters.limit_type}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />
                                                <TextField
                                                    label="Max Different Skus"
                                                    name="max_different_skus"
                                                    value={filters.max_different_skus}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"

                                                />
                                                <TextField
                                                    label="Location Code Format"
                                                    name="location_code_format"
                                                    value={filters.location_code_format}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />

                                                <TextField
                                                    label="Is Stackable"
                                                    name="is_stackable"
                                                    value={filters.is_stackable}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />

                                                <TextField
                                                    label="Vertical Gap (cm)"
                                                    name="vertical_gap_in_cm"
                                                    value={filters.vertical_gap_in_cm}
                                                    onChange={handleFilterChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="normal"
                                                    size="small"
                                                    color="secondary"
                                                />

                                                <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                    Apply Filter
                                                </Button>
                                            </Box>
                                        </Modal>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.map((row, index) => (
                                    <TableRow key={row.id} sx={{
                                        backgroundColor: index % 2 === 0 ?
                                            theme.palette.background.default : alpha(theme.palette.action.hover, 0.04),
                                    }}>
                                        {/* <TableCell>
                                            <Checkbox
                                                size="small"
                                                checked={isSelected(row.id)}
                                                onChange={(event) => handleRowCheckboxClick(event, row.id)}
                                            />
                                        </TableCell> */}
                                        {/* <TableCell>{row.name}</TableCell> */}
                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <span
                                                style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                onClick={() => handleCallEdit(row)}
                                            >
                                                {row.code}
                                            </span>
                                        </TableCell>
                                        <TableCell sx={{ textAlign: 'left' }}>{row.description}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{row.allow_multiple_items === 1 ? "True" : "False"}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{row.limit_type}</TableCell>
                                        {/* <TableCell>{row.max_different_skus}</TableCell> */}
                                        <TableCell sx={{ textAlign: 'center' }}>{row.location_code_format}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{row.is_stackable ? "True" : "False"}</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>{row.vertical_gap_in_cm}</TableCell>
                                        <TableCell sx={{ textAlign: 'center' }}>{row.status ? "Active" : "Inactive"}</TableCell>


                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTableContainer>




            </>)}
            {newLocation && (<>
                <AddNewBintypeMaster handleBackWinderMachineEntry={handlecallback} selectedwarehosue={selectedwarehosue} />
            </>)}

        </Box>
    );
};
export default BintypeMaster;